import { HubConnection } from '@microsoft/signalr';
import { InjectionKey } from 'vue';

export const WorkflowCommunicationHubKey: InjectionKey<HubConnection> = Symbol(
  'WorkflowCommunicationHubKey',
);
